import { autocomplete_params } from './utils';
import autoComplete from '@tarekraafat/autocomplete.js';

export function initAutocomplete()
{
    let target = $('.target_zone_select');

    if (target.length > 0) {
        new autoComplete({
            selector: '.target_zone_select',
            data: {
                src: async (query) => {
                    try {
                        let url = $('.target_zone_select').attr('data-remote-url');
                        const source = await fetch(url + '?term=' + query);
                        const data = await source.json();
                        return data.results;
                    }
                    catch (error) {
                        return error;
                    }
                },
                keys: ['prefix', 'text'],
                results: (list) => {
                    const filteredResults = Array.from(
                        new Set(list.map((value) => value.text))
                    ).map((prev) => {
                        return list.find((value) => value.text === prev);
                    });

                    return filteredResults;
                }
            },
            ...autocomplete_params(),
        });

        target.on('selection', (e) => {
            $(e.currentTarget).val(e.originalEvent.detail.selection.value.id);
            $('input[name=target_zone]').val(e.originalEvent.detail.selection.value.prefix);
        });

        target.on('blur', (e) => {
            let selected = $('input[name=target_zone]').val();
            if (selected == '') {
                $(e.currentTarget).val('');
            }
        });
    }
}
